import CustomToggle from './component'

export default CustomToggle
